import { BRAND_NAME } from '@constants/Validation';
import { useAppContext } from '@utils/appState';
import { Helmet } from 'react-helmet';

const Favicon = () => {
  const {
    state: {
      companyInformation: { companyInfo },
      whiteLabelClient
    }
  } = useAppContext();
  const { tenant } = companyInfo;
  const { name = '' } = tenant || {};
  const faviconIcon = 'data:,';

  return (
    <Helmet>
      <link
        rel='icon'
        type='image/png'
        href={whiteLabelClient ? faviconIcon : '/assets/symbol_pipelyne.png'}
        sizes='16x16'
      />
      <title>{whiteLabelClient ? name : BRAND_NAME}</title>
      <meta name='description' content={whiteLabelClient ? name : BRAND_NAME} />
    </Helmet>
  );
};

export default Favicon;
